exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CouponDiscountBanner_coupon_banner{padding:10px 100px;background:#525264;color:white;border-radius:25px}.CouponDiscountBanner_coupon_banner .CouponDiscountBanner_bold{font-weight:bold}.CouponDiscountBanner_coupon_banner>p{text-align:center}@media only screen and (max-width: 960px){.CouponDiscountBanner_coupon_banner{border-radius:0}}@media only screen and (max-width: 768px){.CouponDiscountBanner_coupon_banner{border-radius:0;padding:14px 20px;font-size:15px}}.CouponDiscountBanner_coupon_banner>p{margin:0px}\n", ""]);

// Exports
exports.locals = {
	"coupon_banner": "CouponDiscountBanner_coupon_banner",
	"bold": "CouponDiscountBanner_bold"
};